(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anie-head"]) return;
  try {
    
(() => {
  let updateId = 0;

  document.addEventListener('cart:update', async (event) => {
    if (event.detail?.data?.didError) return;
    const bag = document.querySelector('[data-anie-bag]');
    if (!bag) return;
    const requestId = ++updateId;

    try {
      let count = event.detail?.resource?.item_count;
      if (!Number.isInteger(count)) {
        const response = await fetch(bag.dataset.cartJson, {
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) return;
        count = (await response.json()).item_count;
      }
      if (requestId !== updateId || !Number.isInteger(count) || count < 0) return;
      document.querySelectorAll('[data-anie-bag]').forEach((link) => {
        link.textContent = `Bag (${count})`;
      });
    } catch {
      // Preserve the last confirmed count if the connection is interrupted.
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
